import { FunctionComponent, ReactElement } from 'react';
import classnames from 'classnames';
import styles from './styles/CheckoutMobileSummaryPriceTable.scss';

type CheckoutMobileSummaryPriceTableRowProps = {
    label?: string | null;
    value?: string | ReactElement | null;
    formatStyle?: string | null;
    hasTopBorder?: boolean | null;
    subLabel?: string | null;
    discountFrom?: string | null;
    isMainPrice?: boolean;
};

export const CheckoutMobileSummaryPriceTableRow: FunctionComponent<
    CheckoutMobileSummaryPriceTableRowProps
> = props => {
    const { label, value, formatStyle, hasTopBorder, discountFrom, isMainPrice } = props;

    if (!label && !value) {
        return null;
    }

    const valueClasses = classnames({
        [styles.discountPrice]: formatStyle === 'DISCOUNT',
        [styles.mainPrice]: isMainPrice,
    });

    return (
        <div className={classnames(styles.priceRow, { [styles.borderTop]: hasTopBorder })}>
            {label}{' '}
            <span>
                {discountFrom && <span className={styles.inactivePrice}>{discountFrom}</span>}{' '}
                <span className={valueClasses}>{value}</span>
            </span>
        </div>
    );
};
